import React from "react";

import { ArrowRight, Briefcase, Calendar, MapPin, Users } from "react-feather";

const HiringCard = ({ job }) => {
  return (
    <div
      className="border shadow-sm mx-4"
      style={{ borderRadius: 5 ,cursor:'pointer'}}
      onClick={() =>
        window.open(
          `/jobdetails/${job?.fld_id}/${job?.fld_title?.replace(/\W|_/g, "")}`,
          "_blank"
        )
      }
    >
      <div className="content p-1   px-8 pt-9 pb-7 rounded-4 mb-9 feature-cardOne-adjustments ">
        <div className="bg-white p-2">
          <div>
            <p className="text-success pb-2" style={{ alignItems: "baseline" }}>
              <MapPin size={12} className=" text-center" />
              <span style={{ fontSize: "12px" }}>
                {" "}
                {job?.fld_city} , {job?.fld_state}
              </span>
            </p>
            <p
              className="text-truncate text-dark mt-0 pb-2"
              style={{ maxWidth: "200px", fontSize: "15px" }}
            >
              {job.fld_title}
            </p>
            <ul className="list-unstyled mb-1 w-70 d-flex ">
              <li>
                <a
                  className="LightBlueWhite font-size-2 rounded-3 p-1"
                  href="/#"
                >
                  {job?.fld_positions} Position
                </a>
              </li>

              <li>
                <a
                  className="OrangeWhite text-eastern font-size-2 rounded-3 p-1 mx-1"
                  href="/#"
                >
                  {job?.fld_type}
                </a>
              </li>
            </ul>
          </div>

          <div className="my-1 d-flex justify-content-between pt-2">
            <span style={{ textAlign: "left", fontSize: "11px" }}>
              Posted {job?.fld_posted_date || "2 days ago"}
            </span>
            <span
              style={{ cursor: "pointer", fontSize: "11px" }}
              className={`btnsAudit px-2 py-1`}
              onClick={() =>
                window.open(
                  `/jobdetails/${job?.fld_id}/${job?.fld_title?.replace(
                    /\W|_/g,
                    ""
                  )}`,
                  "_blank"
                )
              }
            >
              {" "}
              View Details
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HiringCard;
